import { useCallback, useEffect } from 'react';
import { store } from 'redux/store';
import { useLazySeasonalComparatorGetImagesQuery } from 'services/api/Meteorology/Weather/SeasonalComparator';
import { setTriggerFetch } from 'redux/reducers/meteorologyWeatherComparatorControlPanelReducer';
import { ResponseError } from 'services/api/base';
import useImagesParams from './useImagesParams';

export default function useImages() {
  const params = useImagesParams();
  const [trigger, { data, error, isFetching }] = useLazySeasonalComparatorGetImagesQuery();

  const onRetry = useCallback(() => {
    if (params) trigger(params);
  }, [params, trigger]);

  useEffect(() => {
    store.dispatch(setTriggerFetch(params ? (() => trigger(params)) : undefined));
  }, [trigger, params]);

  return {
    images: data,
    queryError: error as ResponseError | undefined,
    onRetry,
    loading: isFetching,
  };
}
